import React, { useState } from "react";
import Header from "../components/Header";
import Footer from "../components/Footer";
import {
  Package,
  HeartHandshake,
  Stethoscope,
  Bus,
  GraduationCap,
  ShieldCheck,
} from "lucide-react";

const OrphanageSupport = () => {
  const [formData, setFormData] = useState({
    orphanageType: "",
    organizationName: "",
    contactNumber: "",
    childrenCount: "",
    certificate: null,
  });

  const orphanageTypes = [
  "Orphanage",
  "Old Age Home",
  "Child Care Institution",
  "Special Needs Home",
  "Rehabilitation Center",
  "Community Welfare Organization",
];

  const childrenCounts = [
    50, 60, 70, 80, 90,
    100, 110, 120, 130, 140,
    150, 160, 170, 180, 190, 200,
  ];

  const handleChange = (e) => {
    const { name, value, files } = e.target;

    if (name === "certificate") {
      setFormData({
        ...formData,
        certificate: files[0],
      });
    } else {
      setFormData({
        ...formData,
        [name]: value,
      });
    }
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    console.log("Submitted Data:", formData);

    alert("Registration Submitted Successfully!");

    setFormData({
      orphanageType: "",
      organizationName: "",
      contactNumber: "",
      childrenCount: "",
      certificate: null,
    });
  };

return (
  <>
    <Header />

    <div className="bg-slate-50 min-h-screen">

      {/* Banner */}
      <div className="relative h-[350px] md:h-[450px] w-full overflow-hidden">
        <img
          src="https://images.unsplash.com/photo-1516627145497-ae6968895b74"
          alt="Orphanage Support"
          className="w-full h-full object-cover"
        />

        <div className="absolute inset-0 bg-black/50"></div>

        <div className="absolute inset-0 flex items-center justify-center">
          <div className="text-center px-4">
            <h1 className="text-white text-4xl md:text-6xl font-extrabold mb-4">
              Community Care Support Program
            </h1>

            <p className="text-white/90 text-lg md:text-xl max-w-3xl">
              Providing affordable oral healthcare products, awareness programs,
              and preventive dental care for orphanages, old age homes, special
              care institutions, and community welfare organizations.
            </p>
          </div>
        </div>
      </div>

      {/* Main Content */}
      <section className="max-w-7xl mx-auto px-6 py-16">

        {/* About Section */}
<div className="mb-16">

  <h2 className="text-4xl font-bold text-slate-900 mb-6">
    Supporting Every Smile, Every Generation
  </h2>

  <p className="text-slate-600 text-lg leading-relaxed w-full">
    Dr. Sridhar Oral Health Foundation is committed to improving oral
    healthcare for orphanages, old age homes, child care institutions,
    special needs centers, rehabilitation facilities, and community
    welfare organizations.

    Through our outreach initiatives, we provide affordable dental
    hygiene products, oral health awareness programs, preventive care,
    and access to mobile dental services.
  </p>

</div>
{/* Program Benefits Heading */}
<div className="mb-10">

  <h3 className="text-3xl font-bold text-slate-900 mb-4">
    Program Benefits
  </h3>

  <p className="text-slate-600 text-lg leading-relaxed"> 
    Our foundation supports institutions through affordable oral care
    products, dental screening camps, educational programs and mobile
    healthcare services.
  </p>

</div>
<div className="grid lg:grid-cols-2 gap-10 items-center mb-20">

  {/* Benefits Side */}
  <div>

    <div className="grid lg:grid-cols-2 sm:grid-cols-1 gap-5">

      {/* Benefit 1 */}
      <div className="bg-white p-6 rounded-2xl shadow-md hover:shadow-xl transition duration-300">
        <Package size={28} className="text-blue-600 mb-4" />
        <h4 className="font-bold text-xl mb-2">
          Affordable Oral Care Products
        </h4>
        <p className="text-slate-600">
          Toothpaste and toothbrushes at subsidized prices.
        </p>
      </div>

      {/* Benefit 2 */}
      <div className="bg-white p-6 rounded-2xl shadow-md hover:shadow-xl transition duration-300">
        <Stethoscope size={28} className="text-blue-600 mb-4" />
        <h4 className="font-bold text-xl mb-2">
          Dental Screening Camps
        </h4>
        <p className="text-slate-600">
          Regular oral healthcare checkups.
        </p>
      </div>

      {/* Benefit 3 */}
      <div className="bg-white p-6 rounded-2xl shadow-md hover:shadow-xl transition duration-300">
        <GraduationCap size={28} className="text-blue-600 mb-4" />
        <h4 className="font-bold text-xl mb-2">
          Awareness Programs
        </h4>
        <p className="text-slate-600">
          Education on oral hygiene and healthy practices.
        </p>
      </div>

      {/* Benefit 4 */}
      <div className="bg-white p-6 rounded-2xl shadow-md hover:shadow-xl transition duration-300">
        <Bus size={28} className="text-blue-600 mb-4" />
        <h4 className="font-bold text-xl mb-2">
          Mobile Dental Clinics
        </h4>
        <p className="text-slate-600">
          Dental care delivered directly to institutions.
        </p>
      </div>

    </div>

  </div>

  {/* Image Side */}
  <div className="flex justify-center">

    <img
      src="https://images.unsplash.com/photo-1516627145497-ae6968895b74"
      alt="Community Care Support"
      className="
        w-full
        max-w-lg
        h-[420px]
        object-cover
        rounded-3xl
        shadow-2xl
        hover:scale-105
        transition-all
        duration-500
      "
    />

  </div>

</div>
      {/* Registration Form */}
<div className="max-w-4xl mx-auto mt-20">

  <div className="bg-white rounded-3xl shadow-xl p-8">

    <h2 className="text-3xl font-bold text-center text-slate-900 mb-2">
      Register Your Institution
    </h2>

    <p className="text-center text-slate-500 mb-8">
      Register your organization to participate in our oral healthcare support initiatives.
    </p>

    <form onSubmit={handleSubmit} className="space-y-5">

      <div>
        <label className="block mb-2 font-semibold">
          Type of Institution *
        </label>

        <select
          required
          name="orphanageType"
          value={formData.orphanageType}
          onChange={handleChange}
          className="w-full border rounded-xl px-4 py-3"
        >
          <option value="">Select Type</option>

          {orphanageTypes.map((type, index) => (
            <option key={index} value={type}>
              {type}
            </option>
          ))}
        </select>
      </div>

      <div>
        <label className="block mb-2 font-semibold">
          Organization Name *
        </label>

        <input
          type="text"
          required
          name="organizationName"
          value={formData.organizationName}
          onChange={handleChange}
          placeholder="Enter organization name"
          className="w-full border rounded-xl px-4 py-3"
        />
      </div>

      <div>
        <label className="block mb-2 font-semibold">
          Contact Number *
        </label>

        <input
          type="tel"
          required
          name="contactNumber"
          value={formData.contactNumber}
          onChange={handleChange}
          placeholder="Enter contact number"
          className="w-full border rounded-xl px-4 py-3"
        />
      </div>

      <div>
        <label className="block mb-2 font-semibold">
          Number of people *
        </label>

        <select
          required
          name="childrenCount"
          value={formData.childrenCount}
          onChange={handleChange}
          className="w-full border rounded-xl px-4 py-3"
        >
          <option value="">Select Number</option>

          {childrenCounts.map((count) => (
            <option key={count} value={count}>
              {count}
            </option>
          ))}
        </select>
      </div>

      <div>
        <label className="block mb-2 font-semibold">
          Upload Institution Certificate (Optional)
        </label>

        <input
          type="file"
          name="certificate"
          onChange={handleChange}
          className="w-full border rounded-xl px-4 py-3"
        />
      </div>

      <button
        type="submit"
        className="w-full bg-blue-600 hover:bg-blue-700 text-white py-3 rounded-xl font-bold"
      >
        Register
      </button>

    </form>

  </div>

</div>
      </section>
    </div>

    <Footer />
  </>
);
};

export default OrphanageSupport;